
import React, { useEffect } from 'react';
import { Form } from '@/components/ui/form';
import { Button } from '@/components/ui/button';
import { Family, Invoice } from '@/types/models';
import { parseCurrencyToCents } from '@/lib/format';
import { useInvoiceForm } from './hooks/useInvoiceForm';
import { InvoiceFormValues } from './hooks/useInvoiceForm'; // Import from the hook
import { FamilySelectField } from './form-fields/FamilySelectField';
import { AmountField } from './form-fields/AmountField';
import { DueDateField } from './form-fields/DueDateField';
import { StatusField } from './form-fields/StatusField';

interface InvoiceFormProps {
  families: Family[];
  invoice?: Invoice;
  onSubmit: (data: InvoiceFormValues) => void;
  onCancel: () => void;
  initialFamilyId?: string;
}

const InvoiceForm: React.FC<InvoiceFormProps> = ({
  families,
  invoice,
  onSubmit,
  onCancel,
  initialFamilyId,
}) => {
  const { form, handleCurrencyChange, formatCurrencyInput } = useInvoiceForm({ invoice, initialFamilyId });

  const handleSubmit = (data: InvoiceFormValues) => {
    // Submit the raw value - parsing will be done in the operation handler
    onSubmit(data);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-6">
        <FamilySelectField form={form} families={families} />
        <AmountField form={form} onCurrencyChange={handleCurrencyChange} />
        <DueDateField form={form} />
        <StatusField form={form} />

        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={onCancel} type="button">
            Cancel
          </Button>
          <Button type="submit">
            {invoice ? 'Save Changes' : 'Create Invoice'}
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default InvoiceForm;
export type { InvoiceFormValues }; // Use export type to resolve the build error
